import { Gift, Lightbulb, Question } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useIntercom } from "react-use-intercom";

import { getUserback } from "common/helpers/userbackClient";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import useWhitelabelCustomization from "common/hooks/useWhitelabelCustomization";
import NavItem from "common/layouts/WorkspaceLayout/NavItem";

import TooltipNavItem from "./TooltipNavItem";

import type { ReactNode } from "react";

import IntercomIcon from "assets/icons/intercom.svg?react";

type ExtraNavItem = {
  label: string;
  icon: ReactNode;
  extraProps?: object;
} & ({ href: string } | { onClick: () => void });

export default function ExtraNavItems({ isExpanded }: { isExpanded: boolean }) {
  const isDesktop = useTwBreakpoint("lg");
  const { show } = useIntercom();
  const { whitelabelCustomization } = useWhitelabelCustomization();

  const extraNavItems: ExtraNavItem[] = [];
  if (!isDesktop) {
    extraNavItems.push({
      icon: <Lightbulb weight="fill" />,
      label: "Feedback & Roadmap",
      onClick: () => getUserback().openForm(),
    });
  }
  if (!whitelabelCustomization) {
    extraNavItems.push({
      icon: <IntercomIcon />,
      label: "Support live chat",
      onClick: show,
    });
  }
  if (!isDesktop) {
    extraNavItems.push({
      icon: <Question weight="fill" />,
      label: "Knowledge base",
      href: "https://help.aimfox.com/en/",
    });
  }

  if (window.Cello && !isDesktop) {
    extraNavItems.unshift({
      icon: <Gift weight="fill" />,
      label: "Referral program",
      onClick: () => {
        window.Cello("open");
      },
      extraProps: { "data-target": "cello-button", className: "relative" },
    });
  }

  return (
    <>
      {extraNavItems.map((item) => {
        const { label, icon, extraProps } = item;

        const navItem = (
          <NavItem
            key={`${label}_extra_nav_item`}
            isExpanded={isExpanded}
            icon={icon}
          >
            {label}
          </NavItem>
        );

        const extraNavItemComponent =
          "href" in item ? (
            <Link to={item.href} key={label} target="_blank" {...extraProps}>
              {navItem}
            </Link>
          ) : (
            <button
              key={label}
              type="button"
              onClick={item.onClick}
              {...extraProps}
            >
              {navItem}
            </button>
          );

        return (
          <TooltipNavItem
            component={extraNavItemComponent}
            isExpanded={isExpanded}
            label={label}
            key={label}
          />
        );
      })}
    </>
  );
}
